<template>
  <div id="aed-icon">
    <svg id="aed-svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2.8346999 2.8346" style="enable-background:new 0 0 2.8346999 2.8346;" xml:space="preserve">
      <g>
        <g>
          <rect class="st8" width="2.8346999" height="2.8346" />
          <path class="st9" d="M1.3433,1.1752C1.5001184,0.974,1.6747999,0.9453,1.8811184,0.987L1.8448,1.0470001 c-0.217-0.0521001-0.3894,0.0393-0.5065,0.2536V1.7993L1.1134,2.2119l0.2327185-0.2011001v0.5040002 C1.6855999,2.332,2.3358998,1.7236,2.1345,1.2981l0.0491998-0.0655C2.4319999,1.7812001,1.7062,2.3815,1.3461185,2.5984001 C0.8941184,2.332,0.6147,2.0264001,0.4786,1.6688C0.3042,1.1281,0.936,0.6971,1.3433,1.1752" />
          <polyline class="st9" points="1.8706,0.3213 2.3982,0.3213 1.9754,0.6919 2.5967999,0.6919 1.3461185,1.9325 2.0693998,0.8827 1.5834999,0.8827" />
          <path class="st9" d="M0.6589,0.7026L0.6041184,0.4675L0.5469,0.7026 M0.5496,0.3527h0.1226l0.1486,0.5641H0.714l-0.0343-0.131 H0.5256l-0.0334816,0.131h-0.102L0.5496,0.3527z" />
          <polyline class="st9" points="0.8551184,0.3527 1.1605999,0.3527 1.1605999,0.4364 0.9592,0.4336 0.9592,0.5716 1.1474999,0.5697 1.1474999,0.6633 0.9592,0.6633 0.9592,0.8174 1.1659,0.8174 1.1659,0.9168 0.8551184,0.9168 		" />
          <path class="st9" d="M1.3224,0.4336V0.833L1.354,0.8354c0.1198,0,0.1276-0.0651,0.1251184-0.2036 c0-0.1358-0.0104184-0.1982-0.1074184-0.1982 M1.2206,0.3527h0.1751c0.1409,0,0.1877999,0.0887,0.1852,0.2767 c-0.0026,0.1409-0.0184,0.2036-0.0836,0.2482c-0.0338,0.0232-0.0811,0.0392-0.1408999,0.0392H1.2233L1.2206,0.3527z" />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>

svg {
  width: 100%;
}

.st8 {
  fill: #ca191d;
}

.st9 {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #ffffff;
}
</style>
